import React from "react";
import Image from "next/image";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const ProductDescription = ({
  heading,
  headingBig,
  paragraphs,
  image,
  sections,
  ulHeading,
  ulImage,
  ulData,
  olHeading,
  olData,
  conclusionHeading,
  conclusionParagraphs,
}) => {
  return (
    <div className="w-full">
      {heading && (
        <h2
          className={`font-bold mb-4 ${
            headingBig ? "text-2xl sm:text-3xl" : "text-2xl"
          }`}
        >
          {heading}
        </h2>
      )}
      {paragraphs &&
        paragraphs.map((paragraph, index) => (
          <p key={index} className="text-lg mb-4">
            {paragraph}
          </p>
        ))}
      {image && (
        <figure className="relative w-full mb-4 flex flex-col gap-2">
          <Image
            src={`${BASE_ASSETS_URL}/v2/alternatives${image.src}`}
            width="10"
            height="10"
            className="w-full h-auto object-cover border"
            alt={image?.alt}
          />
          <figcaption className="text-center px-6 sm:px-10 text-xs sm:text-sm italic">
            {image?.caption}
          </figcaption>
        </figure>
      )}
      {sections?.map((section, index) => (
        <div key={index} className="mb-4">
          {section.heading && (
            <h3 className="text-xl font-bold mb-2">{section.heading}</h3>
          )}
          {section.paragraphs &&
            section.paragraphs.map((paragraph, index) => (
              <p key={index} className="text-lg mb-4">
                {paragraph}
              </p>
            ))}
          {section.image && (
            <figure className="relative w-full mb-4 flex flex-col gap-2">
              <Image
                src={`${BASE_ASSETS_URL}/v2/alternatives${section.image.src}`}
                width="10"
                height="10"
                className="w-full h-auto object-cover border"
                alt={section.image?.alt}
              />
              <figcaption className="text-center px-6 sm:px-10 text-xs sm:text-sm italic">
                {section.image?.caption}
              </figcaption>
            </figure>
          )}
        </div>
      ))}
      {ulHeading && <h3 className="text-xl font-bold mb-2">{ulHeading}</h3>}
      {ulImage && (
        <figure className="relative w-full mb-4 flex flex-col gap-2">
          <Image
            src={`${BASE_ASSETS_URL}/v2/alternatives${ulImage.src}`}
            width="10"
            height="10"
            className="w-full h-auto object-cover border"
            alt={ulImage?.alt}
          />
          <figcaption className="text-center px-6 sm:px-10 text-xs sm:text-sm italic">
            {ulImage?.caption}
          </figcaption>
        </figure>
      )}
      {ulData && (
        <ul className="list-disc pl-6 mb-4 text-gray-900">
          {ulData.map((data, index) => (
            <li key={index} className="text-lg">
              {data?.title && <strong>{data.title}: </strong>}
              {data?.description}
            </li>
          ))}
        </ul>
      )}
      {olHeading && <h3 className="text-xl font-bold mb-2">{olHeading}</h3>}
      {olData && (
        <ol className="list-decimal pl-6 mb-4 text-gray-900">
          {olData.map((data, index) => (
            <li key={index} className="text-lg">
              {data?.title && <strong>{data.title}: </strong>}
              {data?.description}
            </li>
          ))}
        </ol>
      )}
      {conclusionHeading && (
        <h3 className="text-2xl font-bold mb-2">{conclusionHeading}</h3>
      )}
      {conclusionParagraphs &&
        conclusionParagraphs.map((paragraph, index) => (
          <p key={index} className="text-lg mb-4">
            {paragraph}
          </p>
        ))}
    </div>
  );
};

export default ProductDescription;
